import { Pipe, PipeTransform, inject } from '@angular/core'
import { ExportTypeEnum } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateExportType',
    standalone: false
})
export class TranslateExportTypePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(value: ExportTypeEnum): string {
    const translationKey = `TRANSLATE_EXPORT_TYPE.${constantCase(value)}`
    return this.translateService.instant(translationKey)
  }
}
